import React from "react";
import { Dispatcher } from "../../flux";
import { NotebookDialog } from "../../components";
import tourSteps from "./tour";

const onSubmit = function(selectedHighlights) {
  selectedHighlights = selectedHighlights.mine.concat(
    selectedHighlights.theirs
  );
  if (this.state.randomOrder) {
    selectedHighlights = Fraction.Helpers.shuffleArray(selectedHighlights);
  } else {
    selectedHighlights = selectedHighlights.sort(this._compareBookOrder);
  }
  this.setState(
    {
      setupMode: false,
      selectedHighlights: selectedHighlights,
      highlightIndex: 0
    },
    function() {
      Fraction.Helpers.removeModal();
      Dispatcher.emit(Dispatcher.CHANGE_CHROME, "review-mode-chrome", {
        highlights: selectedHighlights
      });
      Fraction.Reporter.gaEvent("review-mode-launched");
    }.bind(this)
  );
};

var ReviewDialogMixin = {
  _reviewModeSetupDialog(isbn) {
    const title = i18n.t("review-mode.customize-your-review");
    const description = i18n.t("review-mode.review-description");
    return {
      title,
      isbn,
      menuId: title,
      closeCallback: function() {},
      buttons: [],
      definingClass: "notebook-modal",
      modalContainerHeader: true,
      width: 570,
      height: 470,
      content: (
        <NotebookDialog
          isbn={isbn}
          title={title}
          onSubmit={onSubmit}
          isReviewMode={true}
        />
      )
    };
  },

  _setupReviewMode(isbn) {
    // First time user clicks review mode, show guided tour (only for desktop)
    var hasShown = Fraction.Helpers.getItem(
      "_" + Fraction.User.email.hashMe() + "_reviewModeShown",
      true
    );

    if (
      !hasShown &&
      !Fraction.Helpers.isSmallScreen() &&
      Fraction.Brand.Onboarding.enabled
    ) {
      Dispatcher.emit(Dispatcher.NEW_TOUR, tourSteps(isbn));
      Fraction.Helpers.setItem(
        "_" + Fraction.User.email.hashMe() + "_reviewModeShown",
        true
      );
    } else {
      const setupDialog = ReviewDialogMixin._reviewModeSetupDialog(isbn);
      if (Fraction.Helpers.isSmallScreen()) {
        setupDialog.intersitial = true;
        setupDialog.definingClass =
          setupDialog.definingClass + " mobile-notebook-dialog";
      }
      Fraction.Helpers.showVSTModal(
        setupDialog,
        $(".launch-review-mode-button")
      );

      Fraction.Reporter.gaEvent("review-mode-button");
    }
  }
};

const _launchTour = function(isbn) {
  Dispatcher.emit(Dispatcher.NEW_TOUR, tourSteps(isbn));
};

module.exports = {
  metadata: () => {
    return {
      id: "review-mode",
      name: i18n.t("review-mode.review-mode"),
      description: i18n.t("review-mode.description"),
      launch: ReviewDialogMixin._setupReviewMode,
      type: "extension"
    };
  }
};
